"use client";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Users from "../components/Users/Users";

export default function UsersPage() {
  const navigate = useNavigate();
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setBusinesses([]);
    setLoading(false);
  }, []);

  return <Users />;
}
